import { isPlainObject, startCase } from "lodash-es"
import React from "react"
import useNotificationTemplateStore from "../notification-template.store"
const Outputs = ({ focused = null }) => {
  const [outputs, setOutput] = useNotificationTemplateStore(store => [
    store.data.dataSource?.outputs,
    store.setOutputVariable,
  ])

  if (!outputs || !isPlainObject(outputs)) return null
  return (
    <div className="grid grid-cols-2 gap-3 mt-3">
      {Object.keys(outputs).map(output => {
        return (
          <button
            onClick={() => {
              setOutput({ key: output, value: outputs[output] })
            }}
            key={output}
            className="bg-green-100 shadow-none outline-none border-none rounded-md text-gray-600 hover:bg-green-200 py-[6px]"
          >
            {startCase(output)}
          </button>
        )
      })}
    </div>
  )
}

export default Outputs
